import { useTranslation } from 'react-i18next';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import Chip from './Chip';

const VALIDATION_COLOR = '#D97706';
const LIVE_COLOR = '#047857';

interface TipsModeChipProps {
    mode: 'ValidationMode' | 'LiveReporting';
    onClick?: () => void;
    size?: 'small' | 'medium';
}

export const TipsModeChip = ({
    mode,
    onClick,
    size = 'medium'
}: TipsModeChipProps) => {
    const { t } = useTranslation();

    const isValidation = mode === 'ValidationMode';
    const color = isValidation ? VALIDATION_COLOR : LIVE_COLOR;
    const chipColor = isValidation ? 'warning' : 'success';
    const height = size === 'small' ? '26px' : '32px';
    const fontSize = size === 'small' ? '13px' : '14px';

    return (
        <Chip
            icon={
                isValidation ? (
                    <VisibilityOutlinedIcon
                        style={{ fontSize: '14px', color }}
                    />
                ) : (
                    <TaskAltIcon style={{ fontSize: '14px', color }} />
                )
            }
            label={
                <span style={{ fontWeight: 700, color, fontSize }}>
                    {isValidation
                        ? t('tips.validation_mode')
                        : t('tips.live_reporting')}
                </span>
            }
            color={chipColor}
            onClick={onClick}
            sx={{
                height,
                px: 0.5,
                cursor: onClick ? 'pointer' : 'default'
            }}
        />
    );
};
